<script>
  // Standardized empty state. Use for zero-result lists, empty detail sections, and
  // onboarding. One implementation so empty states look identical everywhere.
  //
  //   <EmptyState icon="quests" title="No quests yet"
  //     description="Create your first weekly challenge." ctaLabel="New quest" ctaHref="/quests/new" />
  import Icon from './ui/icon.svelte'
  import Button from './ui/button.svelte'

  let { icon = 'unknown', title, description = null, ctaLabel = null, ctaHref = null, onCta = null, children } = $props()
</script>

<div class="flex flex-col items-center text-center py-12 px-4">
  <div class="rounded-full bg-base-200 p-4 mb-4">
    <Icon name={icon} size="xl" class="text-base-content/40" />
  </div>
  <h3 class="font-semibold text-base-content/80">{title}</h3>
  {#if description}<p class="text-sm text-base-content/50 mt-1 max-w-sm">{description}</p>{/if}
  {#if children}
    <div class="mt-4">{@render children()}</div>
  {:else if ctaLabel && (ctaHref || onCta)}
    <div class="mt-4">
      <Button variant="primary" icon="add" href={ctaHref} onclick={onCta}>{ctaLabel}</Button>
    </div>
  {/if}
</div>
